import Header from "@/components/Header";
import Hero from "@/components/Hero";
import CabanasList from "@/components/CabanasList";
import Experiencia from "@/components/Experiencia";
import Faq from "@/components/Faq";
import Footer from "@/components/Footer";

export default function Home() {
  return (
    <div data-testid="home-page">
      <Header />
      <main>
        <Hero />
        <CabanasList />
        <Experiencia />
        <Faq />
      </main>
      <Footer />
    </div>
  );
}
